import { Form, Formik } from "formik"
import { ImportIdCardsFormContent } from "./ImportIdCardsFormContent"
import { ImportIdCardsFormValues, UpdateKeyListIdCards, UserGroup } from "../idCardsTypes"
import { ImportCsvFile } from "../../../../../../shared/components/importCsv/importCsvFileTypes"

type ImportIdCardsFormProps = Readonly<{
    onSubmit: (importData: ImportCsvFile) => void
}>

export const ImportIdCardsForm = ({ onSubmit }: ImportIdCardsFormProps) => {
    const defaultInitialValues = {
        userGroupId: UserGroup.ALL,
        updateKey: UpdateKeyListIdCards.EMAIL,
        updateMatching: false,
        deleteUnmatched: false,
        file: null,
    }

    function handleSubmit({ file, updateMatching, deleteUnmatched, updateKey }: ImportIdCardsFormValues) {
        file && onSubmit({ file, updateMatching, deleteUnmatched, updateKey })
    }

    return (
        <>
            <Formik<ImportIdCardsFormValues>
                enableReinitialize
                initialValues={defaultInitialValues}
                onSubmit={handleSubmit}
            >
                <Form>
                    <ImportIdCardsFormContent />
                </Form>
            </Formik>
        </>
    )
}
